module.exports = __webpack_public_path__ + "static/media/intra_oral_right_small.8c94aefe.png";